import dayjs from "dayjs";
const dayjsFromIso8601 = (iso8601Date: string) =>
  dayjs(iso8601Date);

export const dateShortFromIso8601 = (iso8601Date: string) =>
  dayjsFromIso8601(iso8601Date).format(`YYYY-MM-DD`);

export const dateLongFromIso8601 = (iso8601Date: string) =>
  dayjsFromIso8601(iso8601Date).format(`MMMM D, YYYY`);
